export default "__VITE_ASSET__n2IC$1Ne__"